export const totalPriceCal = () => {
    let savedOrders = localStorage.getItem("savedOrders");
    if (savedOrders && savedOrders !== "null") {
        savedOrders = JSON.parse(savedOrders);
    } else {
        savedOrders = []
    }
    //console.log("savedOrders", savedOrders)
    let totalPrice = 0;
    savedOrders.map((iterator) => {
        totalPrice = totalPrice + iterator.totalPrice;
    })
    //console.log("totalPrice", totalPrice);
    return totalPrice;
}